import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { A11y, Keyboard, Mousewheel } from 'swiper/modules'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'

import ArrowLeft from '../../../../public/svg/arrow-left.svg'
import ArrowRight from '../../../../public/svg/arrow-right.svg'
import { PhnxImageHolder } from '../../01-atoms/ImageHolder/ImageHolder'
import styles from './Logoslider.module.css'

export type LogosliderProps = {
  title: string
  items?: {
    title?: string
    asset: {
      src: string
      alt: string
    }
  }[]
}

export const SwiperNavButtons = () => {
  const swiper = useSwiper()

  const [disablePrev, setDisablePrev] = useState(false)
  const [disableNext, setDisableNext] = useState(false)

  useEffect(() => {
    if (swiper.isBeginning) {
      setDisablePrev(true)
    } else {
      setDisablePrev(false)
    }

    if (swiper.isEnd) {
      setDisableNext(true)
    } else {
      setDisableNext(false)
    }

    swiper.on('slideChange', () => {
      if (swiper.isBeginning) {
        setDisablePrev(true)
      } else {
        setDisablePrev(false)
      }
      if (swiper.isEnd) {
        setDisableNext(true)
      } else {
        setDisableNext(false)
      }
    })
  }, [swiper])

  return (
    <div className={styles['swiper-nav-btns']}>
      <button
        className={`${disablePrev ? styles.disabled : ''}`}
        onClick={() => swiper.slidePrev()}
        disabled={disablePrev}
      >
        <ArrowLeft />
        <span className="sr-only">Prev</span>
      </button>
      <button
        className={`${disableNext ? styles.disabled : ''}`}
        disabled={disableNext}
        onClick={() => swiper.slideNext()}
      >
        <ArrowRight />
        <span className="sr-only">Next</span>
      </button>
    </div>
  )
}

export const PhnxLogoslider: React.FC<LogosliderProps> = ({ title, items }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 800px)' })

  return (
    <div className={`container ${styles['logoslider']}`}>
      <div className={styles['inner-container']}>
        <div className={styles.title}>{title && <p>{title}</p>}</div>
        <div className={styles.slider}>
          {items && items.length > 0 && (
            <Swiper
              slidesPerView={isDesktop ? 5 : 2}
              spaceBetween={10}
              keyboard={{
                enabled: true,
              }}
              mousewheel={true}
              modules={[A11y, Keyboard, Mousewheel]}
              className="mySwiper"
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className={styles.slide}>
                    <div className={styles.content}>
                      <PhnxImageHolder images={[item.asset]} />
                    </div>
                    {item.title}
                  </div>
                </SwiperSlide>
              ))}
              {/* <SwiperNavButtons /> */}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  )
}
